module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4121@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4121%402x.png
// module id = aqbv
// module chunks = 93